<fun-overal-message *ngIf="!loading" [text]="text" [image]="image" [btnList]="btnList" (btnEvent)="subscribe($event)"></fun-overal-message>
<fun-spinner *ngIf="loading"></fun-spinner>